'use es6';

import { Record } from 'immutable';
import { BASE_FIELDS } from 'AdsUI/records/reporting/AdWordsGenericAdReportingRecord';
export default Record(Object.assign({}, BASE_FIELDS, {
  mimeType: null,
  previewUrl: null,
  previewWidth: null,
  previewHeight: null
}));